import './AnnouncementBasic.scss';

interface IAnnouncementBasicProps {
  className?: string;
  icon?: string;
  text: string | JSX.Element;
  link?: {
    label: string;
    onClick: () => void;
    className?: string;
  };
}

const AnnouncementBasic = ({ className, icon, text, link }: IAnnouncementBasicProps) => {
  return (
    <div className={`announcement-basic ${className}`}>
      {icon && <img src={icon} alt='icon' style={{ marginRight: '8px' }} />}
      {text}
      {link && 
        <div className='row'>
          <span className={`link ${link.className}`} onClick={link.onClick}>{link.label}</span>
        </div>
      }
    </div>
  )
}

export default AnnouncementBasic;